import { useGetRequest } from "@ch/api/useGetRequest";
import {
  LanguageControllerService,
  type LanguageWithRelations,
} from "@ch/generated";
import { useMemo } from "react";

type TLanguage = Required<LanguageWithRelations>;

function useGetLanguages() {
  const { data, loading } = useGetRequest({
    service: LanguageControllerService.languageControllerFind,
    tag: "languageControllerFind",
    payload: {
      filter: {},
    },
  });

  const languageOptions = useMemo(
    () =>
      data?.map((item) => ({
        label: item.name,
        value: item.id!,
      })),
    [data],
  );

  return {
    languages: (data as TLanguage[]) ?? [],
    languageOptions: languageOptions ?? [],
    loading,
  };
}

export default useGetLanguages;
